<app-simple-widget
	*ngIf="!widgetConfig.hideWidget && widgetConfig.data"
	[title]="widgetConfig.title"
	[tooltipKey]="widgetConfig.tooltip"
>
	<div class="panel-body" *ngIf="!isCollapsed">
		<app-print-filters #printFiltersRef [title]="widgetConfig.title" [filters]="printFilters"></app-print-filters>
		<div class="row noprint mb-4">
			<ng-container *ngFor="let dropDownGroup of widgetConfig.dropDownGroupList; let i = index">
				<div class="col-sm-6 col-md-2 pb-1 d-inline-flex">
					<select
						*ngIf="dropDownGroup.name != 'tags'; else tagsDropDown"
						class="form-control input-sm"
						[(ngModel)]="selectedDropDown[dropDownGroup.name]"
						(change)="onFilter([dropDownGroup.name, $event.target.value])"
					>
						<option *ngFor="let option of dropDownGroup.options" [value]="option.value">
							{{option.label}}
						</option>
					</select>
				</div>
			</ng-container>
			<div class="d-inline-flex ml-auto">
				<a class="btn btn-xs" (click)="onPrint()" href="javascript:" *ngIf="!noDataForCurrentFilters">
					<i class="fa fa-print"></i>
				</a>
			</div>
			<ng-template #tagsDropDown>
				<ng-select
					[multiple]="true"
					[items]="tags"
					[addTag]="false"
					[clearable]="false"
					[hideSelected]="true"
					bindLabel="tag_name"
					bindValue="id"
					(add)="onFilter(['tags', $event])"
					(remove)="onFilter(['tags', $event])"
					[placeholder]="'tags.filter_by_tag' | translate"
					[(ngModel)]="selectedTags"
				></ng-select>
			</ng-template>
		</div>

		<div class="margin-top-5 row" *ngIf="!noDataForCurrentFilters">
			<div [class]="'col-md-12'" [id]="widgetConfig.widgetId">
				<sct-charts
					[data]="widgetConfig.data"
					[columnNames]="widgetConfig.columnNames"
					[options]="widgetConfig.config"
					[type]="widgetConfig.type"
					[height]="500"
					[title]="widgetConfig.title"
					(select)="onSelect($event)"
				></sct-charts>
			</div>
			<div *ngIf="tableItems.length > 0" class="col-md-12 mt-auto mb-4 noprint">
				<sct-custom-table
					[columnsConfig]="chartTableConfig.column"
					[data]="tableItems"
					[config]="{}"
				>
				</sct-custom-table>
				<a *ngIf="tableColumns && tableItems.length > itemsPerPage" (click)="modal.show()" class="text-center pie-view-more noprint" style="margin-top: 10px" href="javascript:">{{'g.view_more' | translate}}</a>

				<app-modal #modal [title]="widgetConfig.title" [hasConfirmButton]="false" [hasCloseButton]="true" [size]="'lg'">
					<sct-custom-table
						*ngIf="modal.render"
						[columnsConfig]="chartTableConfig.column"
						[data]="chartTableConfig.data"
						[config]="{}"
					>
					</sct-custom-table>
				</app-modal>
			</div>
		</div>

		<div class="alert alert-info" *ngIf="noDataForCurrentFilters">{{'g.no_data_available' | translate}}</div>
	</div>
</app-simple-widget>
